export default "__VITE_ASSET__BYvLB9Rl__"